import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConstantService, DateFormate, IndexValue, LocalStorage, SessionStorage } from './constant.service';
import { StorageService } from './storage.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { environment } from '../../environments/environment';
import { SessionStorageService } from './session-storage.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  
    private getPassedData = new BehaviorSubject<any>('default message');
    setPassedData = this.getPassedData.asObservable();
    setEventSubject = this.getPassedData.asObservable();
    tokenValue! :string;
    appSource! : string;
    tokenVal: any;

    constructor(
        private ConstantService: ConstantService,
        private storageService: StorageService,
        private sanitizer: DomSanitizer,
        private datePipe: DatePipe,
        private sessionStorageService: SessionStorageService,
    ) {}

   
    GenerateCheckSum(parameters: string, appSourceValue: string = '') {
        const appSource: string =
          appSourceValue == ''
            ? this.sessionStorageService.getItem(LocalStorage.appSource) || ''
            : appSourceValue;
        const merchantKey =
          environment.accopeningUserPassAuthCheck.get(appSource)?.[
            IndexValue.checkSum
          ][1];
        const id = merchantKey + parameters;
        const md5Hash = CryptoJS.MD5(id);
        return md5Hash.toString().substr(0, 16).toUpperCase();
      }

    ConvertTextToBase64(inputText : string) {
        const val = CryptoJS.enc.Utf8.parse(inputText);
        const base64 = CryptoJS.enc.Base64.stringify(val);
        return base64;
    }

    getTokenRequest() {
        const request = {
            RequestSource: localStorage.getItem(this.ConstantService.localStorageElement.subSource)
        };
        return request;
    }

    goToPrevPage() {
        window.history.back();
    }

    getAuthKey(appSource: string) {
        return (
            'Basic ' +
            this.ConvertTextToBase64(
                environment.accopeningUserPassAuthCheck.get(appSource)?.[IndexValue.user][1] +
                    ':' +
                    environment.accopeningUserPassAuthCheck.get(appSource)?.[IndexValue.pass][1]
            )
        );
    }

    
    getAuthenticationKey(appSource:string) {
        return (
            environment.accopeningUserPassAuthCheck.get(appSource)?.[IndexValue.Auth][1] +
            ':' +
            localStorage.getItem(this.ConstantService.localStorageElement.activationToken)
        );
    }

    getAuthorizationKey(appSource: string) {
        return (
          environment.accopeningUserPassAuthCheck.get(appSource)?.[
            IndexValue.Auth
          ][1] +
          ':' +
          this.sessionStorageService.getItem(SessionStorage.authenticationkey)
        );
      }

    getUserId(clientCode:string) {
        let userId = localStorage.getItem('userID');
        return userId != null || userId != undefined ? userId : clientCode;
    }

    getUserType() {
        let userId = localStorage.getItem('userID');
        return userId != null || userId != undefined ? 'RM' : 'Client';
    }

    get checkSumDate() {
        const localDate = new Date();
        return this.datePipe.transform(localDate, DateFormate.ddMMyy);
    }
    
}
